<template>
  <b-modal
    hide-footer
    size="sm"
    title="Unblock Account"
    centered
    id="un-block-modal"
    @hide="hideModal"
  >
    <!-- TITLE -->
    <div class="text-center">
      <h4 class="font-weight-bold text-black">Unblock Account</h4>
    </div>

    <!-- SUBTITLE -->
    <p class="text-center text-muted mb-1">
      This will immediately Unblock the account. <br />
      You can unblock the account at any given time.
    </p>

    <!-- REASON -->
    <b-form-group
      label="Reason*"
      class="text-black"
      label-class="font-weight-bold"
    >
      <b-form-textarea
        v-model="form.reason"
        placeholder="Provide reason here"
        rows="3"
        class="rounded-lg"
      ></b-form-textarea>
    </b-form-group>

    <!-- BUTTONS FOOTER LIKE IMAGE -->
    <div class="d-flex justify-content-between mt-2" style="gap: 8px">
      <b-button
        class="font-weight-bold"
        style="flex: 1"
        @click="$bvModal.hide('un-block-modal')"
      >
        CANCEL
      </b-button>

      <b-button
        variant="danger"
        class="font-weight-bold text-nowrap"
        style="flex: 1"
        :disabled="loadingClientProfile"
        @click="handleVerifyProfile"
      >
        <Spinner v-if="loadingClientProfile" />
        <template v-else> UNBLOCK ACCOUNT </template>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import Spinner from "@/@core/components/Spinner.vue";
import useToastHandler from "@/services/toastHandler";
import { BModal, BFormGroup, BFormTextarea, BButton } from "bootstrap-vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    BModal,
    BFormGroup,
    BFormTextarea,
    BButton,
    Spinner,
  },
  data() {
    return {
      form: {
        reason: "",
      },
    };
  },
  computed: {
    ...mapState("user/detail", ["loadingClientProfile"]),
  },
  methods: {
    ...mapActions({
      updateClientProfile: "user/detail/updateClientProfile",
      fetchUser: "user/detail/asyncUser",
    }),
    async handleVerifyProfile() {
      const result = await this.updateClientProfile({
        userId: this.$route.params.id,
        isBlocked: 0,
        reasonUpdate: this.form.reason,
      });
      if (result) {
        this.showToastSuccess("Unblock Account successfully!");
        this.$bvModal.hide("un-block-modal");
        this.fetchUser({ id: this.$router.currentRoute.params.id });
      }
    },
    hideModal() {
      this.form.reason = "";
    },
  },
  setup() {
    const { showToastSuccess, showToastError } = useToastHandler();

    return {
      showToastSuccess,
      showToastError,
    };
  },
};
</script>
